import { privacyPolicyLink, termsAndConditionsLink } from 'config';

const externalLinks = [
  {
    title: 'App',
    links: [
      {
        title: 'Terms and conditions',
        href: termsAndConditionsLink,
      },
      {
        title: 'Privacy policy',
        href: privacyPolicyLink,
      },
    ],
  },
  {
    title: 'Landlord',
    links: [
      {
        title: 'Landlord obligations',
        href: 'https://propa.co.uk/legal/landlord-obligations',
      },
      {
        title: 'Renting out your property',
        href: 'https://www.gov.uk/renting-out-a-property',
      },
      {
        title: 'Right to rent',
        href: 'https://www.gov.uk/check-tenant-right-to-rent-documents',
      },
      {
        title: 'Deposit protection',
        href: 'https://www.gov.uk/tenancy-deposit-protection',
      },
    ],
  },
  {
    title: 'Tenant',
    links: [
      {
        title: 'Tenant obligations',
        href: 'https://propa.co.uk/legal/tenant-obligations',
      },
      {
        title: 'Private renting guidance',
        href: 'https://www.gov.uk/private-renting',
      },
      {
        title: 'How to rent checklist',
        href: 'https://www.gov.uk/government/publications/how-to-rent/how-to-rent-the-checklist-for-renting-in-england',
      },
    ],
  },
];

export default externalLinks;
